
import { defineComponent, reactive, toRefs, computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import { addOrModifyApiParam } from "@/service/api";
import { ElMessage } from "element-plus";
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      default: {},
    },
    apiId: {
      type: String,
      default: "",
    },
  },
  emits: ["handleSearch", "close-modal"],
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const state = reactive({
      formItem: {
        id: "", //接口参数id
        apiId: "", // 接口id
        paramName: "", //参数名
        type: "string", // 类型
        example: "", //示例
        description: "", //说明
        isRequire: "1", //是否必填
        sort: "", //序号
        userId: computed(() => store.state.manageUser.userId),
          userRealname: computed(() => store.state.manageUser.name),
      },
      typeList: [
        {
          label: "string",
        },
        {
          label: "int",
        },
        {
          label: "long",
        },
        {
          label: "float",
        },
        {
          label: "double",
        },
        {
          label: "boolean",
        },
        {
          label: "array",
        },
      ],
      clickModalClose: false,
      ruleValidate: {
        paramName: [
          {
            required: true,
            message: "请输入参数名",
            trigger: "blur",
          },
        ],
        isRequire: [
          {
            required: true,
            message: "请选择是否必填",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
      },
    });
    const ruleForm = ref<any>(null);
    const loading = ref(true);
    //点击确定
    function addSubmit() {
      ruleForm.value.validate(async (valid: boolean) => {
        if (valid) {
          const para = Object.assign({}, state.formItem);
          const result = await addOrModifyApiParam(para);
          if (result && parseInt(result.code) === 1) {
            ElMessage({ message: props.title + "成功", type: "success" });
            cancel();
            context.emit("handleSearch");
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          return false;
        }
      });
    }
    //取消审核
    function cancel() {
      ruleForm.value.resetFields();
      state.formItem.id = "";
      state.formItem.apiId = "";
      state.formItem.sort = "";
      state.formItem.paramName = "";
      state.formItem.type = "string";
      state.formItem.example = "";
      state.formItem.description = "";
      state.formItem.isRequire = "1";
      state.formItem.sort = "";
      context.emit("close-modal");
    }
    watch(
      () => props.dialogVisible,
      (newVal) => {
        if (newVal) {
          loading.value = true;
          state.formItem.apiId = props.apiId;
          if (props.formData.id != "" && props.formData.id != undefined) {
            state.formItem.id = props.formData.id;
            state.formItem.paramName = props.formData.paramName;
            state.formItem.type = props.formData.type;
            state.formItem.example = props.formData.example;
            state.formItem.description = props.formData.description;
            state.formItem.isRequire = props.formData.isRequire ? "1" : "0";
            state.formItem.sort = props.formData.sort;
          }
          loading.value = false;
        }
      }
    );
    return {
      ...toRefs(state),
      ruleForm,
      cancel,
      addSubmit,
      loading,
    };
  },
});
